module.exports = __webpack_public_path__ + "img/DSC_1298_3.f5ad85f7.jpg";